/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/

const Chars = {
	DOT: '.',
	OSBRACKET: '[',
	CSBRACKET: ']',
	QUTOE: '"'
};

const State = {
	READY: 1,
	QUOTE: 2,
	BRACKET: 4
};

const createState = () => {
	const stack = [State.READY];
	return {
		put: (newstate) => {
			stack.push(newstate);
			return newstate;
		},
		pop: () => stack.pop(),
		is: (instate) => stack[stack.length - 1] === instate
	}
};
const push = (part, toParts) => {
	if (part.length) toParts.push(part.join(''));
	part.length = 0;
};
const parse = (str = '') => {
	const part = [];
	const parts = [];
	const state = createState();
	for (let i = 0; i < str.length; i += 1) {
		const ch = str.charAt(i);
		if (ch === Chars.QUTOE) {
			if (state.is(State.QUOTE)) state.pop();
			else state.put(State.QUOTE);
		}
		else if (ch === Chars.OSBRACKET) {
			if (state.is(State.QUOTE) || state.is(State.BRACKET)) part.push(ch);
			else state.put(State.BRACKET);
		}
		else if (ch === Chars.CSBRACKET) {
			if (state.is(State.BRACKET)) {
				state.pop();
				push(part, parts);
			}
			else if (state.is(State.QUOTE)) part.push(ch);
		}
		else if (ch === Chars.DOT) {
			if (state.is(State.QUOTE) || state.is(State.BRACKET)) part.push(ch);
			else push(part, parts);
		}
		else part.push(ch);
	}
	push(part, parts);
	return parts;
};

const parseDot = (str = '') => {
	const part = [];
	const parts = [];
	const state = createState();
	for (let i = 0; i < str.length; i += 1) {
		const ch = str.charAt(i);
		if (ch === Chars.QUTOE) {
			if (state.is(State.QUOTE)) state.pop();
			else state.put(State.QUOTE);
		}
		else if (ch === Chars.DOT) {
			if (state.is(State.QUOTE)) part.push(ch);
			else push(part, parts);
		}
		else part.push(ch);
	}
	push(part, parts);
	return parts;
};

const containsChar = (chars = []) => (str) => chars.some((c) => str.includes(c));
const containsReservedChar = containsChar([Chars.DOT, Chars.OSBRACKET, Chars.CSBRACKET]);
const quote = (part) => containsReservedChar(part) ? `"${part}"` : part;
const empty = (part) => !!part;

const toString = (path = []) => path.filter(empty).map(quote).join('.');

// append instead of concat since part might be quoted while prefix is assumed to be checked already
const append = (part, prefix) => prefix ? `${prefix}.${quote(part)}` : quote(part);

module.exports = {
	parse,
	parseDot,
	append,
	toString
}
